"use client";

import { Button, Icon, useToast } from "@stone-payments/jade";
import { Skeleton } from "@/components/skeleton";

type Props = {
  productName: string;
  onAdd: () => void;
  loading?: boolean;
  disabled?: boolean;
};

export const AddCartButton = ({
  productName,
  onAdd,
  loading = true,
  disabled = false,
}: Props) => {
  const { addToast } = useToast();

  if (loading) return <Skeleton height="h-12" width="w-full" />;

  const addToCart = () => {
    addToast({
      leading: <Icon color="on-color-high" size="large" use="cart-plus" />,
      text: `Boa escolha! ${productName} foi adicionado ao carrinho.`,
    });

    onAdd();
  };

  return (
    <Button
      icon={disabled ? "circle-alert" : "cart-plus"}
      onClick={addToCart}
      size="large"
      variant="primary-solid"
      data-testid="add-to-cart-button"
      disabled={disabled}
    >
      {disabled ? "Produto indisponível" : "Adicionar ao carrinho"}
    </Button>
  );
};
